import { PATCHBranchRequest } from 'api/types'
import { FormValues } from 'modules/Projects/EditBranch'

export const editBranchMutationData = (
  formValues: FormValues
): PATCHBranchRequest => ({
  defaultEnvironmentId: formValues.defaultEnvironment.id
})
